import ReactGA from 'react-ga';

ReactGA.initialize('UA-113641245-3', {
  testMode: process.env.NODE_ENV !== 'production',
});
ReactGA.pageview(window.location.pathname + window.location.search);
